// extracted by mini-css-extract-plugin
module.exports = {"container":"gk","image":"gl","title":"gm","desc":"gn"};